export default __webpack_public_path__ + "static/media/link.56ef06b0.svg";